import CardContainer from 'src/components/CardContainer/CardContainer';
import { clsx } from 'clsx';
import { useGetProjectByIdQuery } from 'src/services';
import { Link, useParams } from 'react-router-dom';
import { useAppSelector } from 'src/store';
import { GoToButton } from 'src/components/ButtonWithIcon/GoToButton';
import { PATH_DASHBOARD } from 'src/constants/spa-routes';
import { RepliesLine } from 'src/pages/ControlDeskPage/RepliesBalanceSection/RepliesLine';
import { useGetAccountsQuery } from 'src/services/accountsService';
import { LoaderWrapper } from 'src/components/LoaderWrapper/LoaderWrapper';
import { Skeleton } from 'src/components/ui/skeleton';
import { Button } from 'src/components/ui/button';
import { SUBSCRIPTION_ACCESS_ROLES } from 'src/constants/roles';
import { useGetUsersMeQuery } from 'src/services/usersService';
import { WarningPopover } from 'src/components/WarningPopower/WarningPopover';

const LaunchIcon = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_32315_723)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.249 7.00088C1.24875 5.78507 1.63383 4.60047 2.34892 3.61719C3.06401 2.63392 4.07233 1.90257 5.22905 1.52818C6.38578 1.15378 7.6314 1.15561 8.78702 1.5334C9.94264 1.91119 10.9488 2.64551 11.661 3.63088L11.146 4.14588C11.0759 4.21581 11.0281 4.30498 11.0088 4.40209C10.9894 4.49919 10.9993 4.59987 11.0372 4.69134C11.0751 4.78281 11.1394 4.86097 11.2217 4.9159C11.3041 4.97083 11.401 5.00005 11.5 4.99988H13.5C13.6326 4.99988 13.7598 4.9472 13.8536 4.85343C13.9473 4.75966 14 4.63248 14 4.49988V2.49988C14.0002 2.40086 13.9709 2.30401 13.916 2.22162C13.8611 2.13923 13.7829 2.07501 13.6915 2.03709C13.6 1.99917 13.4993 1.98927 13.4022 2.00864C13.3051 2.02801 13.2159 2.07577 13.146 2.14588L12.554 2.73888C11.6634 1.57893 10.4319 0.726995 9.03241 0.302661C7.63291 -0.121673 6.13566 -0.097102 4.75084 0.372925C3.36602 0.842953 2.16315 1.73484 1.31109 2.92338C0.459023 4.11193 0.000540698 5.53746 0 6.99988C0 7.16564 0.065848 7.32461 0.183058 7.44182C0.300269 7.55903 0.45924 7.62488 0.625 7.62488C0.79076 7.62488 0.949731 7.55903 1.06694 7.44182C1.18415 7.32461 1.25 7.16564 1.25 6.99988M7 2.87488C7.345 2.87488 7.625 3.15488 7.625 3.49988V4.05688C7.9525 4.10032 8.26158 4.23356 8.51803 4.44182C8.77448 4.65009 8.96829 4.92526 9.078 5.23688C9.10856 5.31495 9.12309 5.39838 9.12074 5.48219C9.11839 5.566 9.0992 5.64847 9.06431 5.72471C9.02942 5.80095 8.97956 5.86939 8.91767 5.92596C8.85579 5.98253 8.78316 6.02607 8.7041 6.05399C8.62505 6.08191 8.54118 6.09363 8.4575 6.08847C8.37381 6.08331 8.29202 6.06136 8.217 6.02393C8.14197 5.98651 8.07524 5.93437 8.02079 5.87062C7.96633 5.80688 7.92525 5.73283 7.9 5.65288C7.86284 5.5471 7.79367 5.45552 7.70211 5.39083C7.61054 5.32614 7.50111 5.29156 7.389 5.29188H6.486C6.38281 5.29088 6.28293 5.32827 6.20577 5.39678C6.1286 5.4653 6.07966 5.56005 6.06844 5.66263C6.05722 5.76522 6.08453 5.86831 6.14506 5.95188C6.2056 6.03546 6.29503 6.09355 6.396 6.11488L7.772 6.41488C8.18445 6.5044 8.55207 6.73663 8.81008 7.07064C9.06808 7.40465 9.19992 7.81901 9.18235 8.2407C9.16478 8.66239 8.99893 9.06435 8.71403 9.37574C8.42914 9.68714 8.04347 9.88798 7.625 9.94288V10.4999C7.625 10.6656 7.55915 10.8246 7.44194 10.9418C7.32473 11.059 7.16576 11.1249 7 11.1249C6.83424 11.1249 6.67527 11.059 6.55806 10.9418C6.44085 10.8246 6.375 10.6656 6.375 10.4999V9.94288C6.0475 9.89943 5.73842 9.7662 5.48197 9.55793C5.22552 9.34967 5.03171 9.07449 4.922 8.76288C4.89144 8.6848 4.87691 8.60138 4.87926 8.51757C4.88161 8.43376 4.9008 8.35128 4.93569 8.27504C4.97057 8.1988 5.02044 8.13036 5.08233 8.07379C5.14421 8.01722 5.21684 7.97368 5.2959 7.94577C5.37496 7.91785 5.45882 7.90612 5.5425 7.91128C5.62619 7.91645 5.70797 7.93839 5.783 7.97582C5.85803 8.01324 5.92475 8.06538 5.97921 8.12913C6.03367 8.19287 6.07475 8.26693 6.1 8.34688C6.13716 8.45265 6.20633 8.54423 6.29789 8.60892C6.38946 8.67361 6.49889 8.70819 6.611 8.70788H7.389C7.5223 8.70739 7.65075 8.6578 7.74979 8.56858C7.84883 8.47936 7.91152 8.35677 7.92587 8.22424C7.94022 8.09172 7.90524 7.95855 7.82759 7.85019C7.74995 7.74184 7.6351 7.66589 7.505 7.63688L6.13 7.33588C5.73784 7.25026 5.38978 7.02593 5.14982 6.70415C4.90987 6.38238 4.79415 5.98478 4.82396 5.5845C4.85377 5.18421 5.0271 4.80814 5.31207 4.52545C5.59703 4.24276 5.97448 4.07247 6.375 4.04588V3.49988C6.375 3.15488 6.655 2.87488 7 2.87488ZM0.309 11.9619C0.217564 11.9241 0.139396 11.86 0.0843905 11.7778C0.0293854 11.6955 1.60608e-05 11.5988 0 11.4999L0 9.49988C0 9.36727 0.0526784 9.24009 0.146447 9.14632C0.240215 9.05256 0.367392 8.99988 0.5 8.99988H2.5C2.59902 8.9997 2.69586 9.02893 2.77825 9.08386C2.86064 9.13879 2.92487 9.21694 2.96278 9.30841C3.0007 9.39989 3.0106 9.50056 2.99124 9.59767C2.97187 9.69478 2.92411 9.78395 2.854 9.85388L2.339 10.3679C3.0512 11.3532 4.05736 12.0876 5.21298 12.4653C6.3686 12.8431 7.61422 12.845 8.77095 12.4706C9.92767 12.0962 10.936 11.3648 11.6511 10.3816C12.3662 9.39829 12.7512 8.21368 12.751 6.99788C12.7511 6.9158 12.7673 6.83454 12.7988 6.75874C12.8302 6.68293 12.8763 6.61407 12.9344 6.55608C12.9925 6.49809 13.0614 6.45211 13.1373 6.42076C13.2131 6.38941 13.2944 6.37331 13.3765 6.37338C13.4586 6.37344 13.5398 6.38967 13.6156 6.42114C13.6914 6.45261 13.7603 6.49871 13.8183 6.55679C13.8763 6.61487 13.9223 6.68381 13.9536 6.75966C13.985 6.83552 14.0011 6.9168 14.001 6.99888C14.0009 8.46163 13.5427 9.88762 12.6907 11.0766C11.8386 12.2656 10.6356 13.1578 9.25047 13.628C7.86535 14.0982 6.36774 14.1228 4.96796 13.6982C3.56818 13.2736 2.33654 12.4213 1.446 11.2609L0.854 11.8539C0.784022 11.9238 0.694892 11.9713 0.597882 11.9905C0.500872 12.0098 0.40034 11.9998 0.309 11.9619Z"
          fill="#05050D"
          fillOpacity="0.8"
        />
      </g>
      <defs>
        <clipPath id="clip0_32315_723">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const RepliesBalanceSection = ({ isTrialPlan }: { isTrialPlan: boolean }) => {
  const { isInactivePlan } = useAppSelector((s) => s.planSlice);
  const { id } = useParams();

  const { data: currentProject } = useGetProjectByIdQuery({ id: id });

  const { data: account, isLoading: isLoadingAccount } = useGetAccountsQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  const isEmpty = !Object.keys(account?.general_plan || {})?.length;

  const generalPlan = account?.general_plan;

  const { data: userInfo } = useGetUsersMeQuery();
  const disabledButton = !SUBSCRIPTION_ACCESS_ROLES.includes(userInfo?.role);

  return (
    <CardContainer className="integration">
      <div
        className={clsx(
          (!currentProject?.is_active || isInactivePlan) && 'opacity-30 pointer-events-none',
          'card-header z-50',
        )}
      >
        <div className="title cursor-default flex justify-between w-full relative">
          <span className="!no-underline max-md:hidden text-sm font-bold text-[#7A6BE5]">
            Replies balance
          </span>
          {isTrialPlan ? (
            <Link
              className={clsx(disabledButton && 'opacity-50 pointer-events-none')}
              to={PATH_DASHBOARD.SUBSCRIPTION}
            >
              <Button variant="outline" size="sm" className="shadow-search gap-2 p-2.5">
                Launch Subscription
                <LaunchIcon />
              </Button>
            </Link>
          ) : (
            <GoToButton
              className={clsx(disabledButton && 'opacity-50 pointer-events-none')}
              href={PATH_DASHBOARD.SUBSCRIPTION}
            />
          )}
          {disabledButton && (
            <WarningPopover triggerClassName="absolute -right-2 -top-2" fill="black" />
          )}
        </div>
      </div>
      <div
        className={clsx(
          (!currentProject?.is_active || isInactivePlan) && 'opacity-30 pointer-events-none',
          'card-body flex w-full gap-2.5 max-md:flex-col',
        )}
      >
        {isEmpty ? (
          <div className="empty-message w-full">
            <LoaderWrapper
              loader={<Skeleton className="w-full h-2" />}
              isLoading={isLoadingAccount}
            >
              <p className="opacity-70 font-semibold text-base text-ebony">
                No active subscription.
              </p>
            </LoaderWrapper>
          </div>
        ) : (
          <RepliesLine generalPlan={generalPlan} />
        )}
      </div>
    </CardContainer>
  );
};
